/* eslint-disable @typescript-eslint/naming-convention */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import { HighchartsChartModule } from 'highcharts-angular';
HighchartsMore(Highcharts);

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-vertical-bar-chart',
  templateUrl: './m-vertical-bar-chart.component.html',
  styleUrls: ['./m-vertical-bar-chart.component.scss'],
  imports: [HighchartsChartModule]
})
export class MVerticalBarChartComponent implements OnInit {
  @Input() series: Highcharts.SeriesOptionsType[] = [];
  @Input() yAxis: Highcharts.YAxisOptions | Highcharts.YAxisOptions[] = {};
  @Input() xAxis: Highcharts.XAxisOptions | Highcharts.XAxisOptions[] = {};
  @Input() legend: Highcharts.LegendOptions = {};
  @Input() plotOptions: Highcharts.PlotOptions = {};
  @Input() tooltip: Highcharts.TooltipOptions = {};
  @Input() width: number | string = 600; // Default width
  @Input() height: number | string = 300; // Default height

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  ngOnInit(): void {
    this.chartOptions = {
      chart: {
        backgroundColor: 'transparent',
        type: 'column',
        height: this.height,
        width: this.width
      },
      credits: { enabled: false },
      exporting: { enabled: false },
      legend: this.legend,
      title: { text: '' },
      xAxis: this.xAxis,
      yAxis: this.yAxis,
      plotOptions: this.plotOptions,
      tooltip: this.tooltip,
      series: this.series
    };
  }
}
